import { Edit, NavigateNext } from '@mui/icons-material';
import { Breadcrumbs, IconButton, Typography } from '@mui/material';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link, matchPath, Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { connect } from 'react-redux';
import { Loading } from "../../../redux/action";
import MaterialSymbol from '../../../components/icons/material-symbol';
import NewAutomationPost from './new-automation-post';
import NewAutomationStory from './new-automation-story';
// import phoneMockup from '../../../assets/images/phone-mockup.png';
// import productImage from '../../../assets/images/product-img1.png';

// import userAvatar from '../../../assets/images/avtar_male.png';
// import Slider from 'react-slick';
import { InstagramDMAutomation } from '../../../core/services/dm-automation-instagram.service';
import * as gtUtil from "../../../core/utility";
import { LocalService } from '../../../core/services';
import { AutomationCompleteFormData } from 'custom-type';

const instagramDMAutomationService: InstagramDMAutomation = new InstagramDMAutomation();
const localService = new LocalService();

// type Props = {}
interface Props {
  UserReducer: any;
}

// const NewAutomation = (props: Props) => {
const NewAutomation: React.FC<Props> = (props: Props) => {
  const { ig_automation_id } = useParams();
  const [automationSelect, setAutomationSelect] = useState({
    post: 'post',
  });
  const  [automationTitle, setAutomationTitle] = useState<string>('untitled automation');
  const [editTitle, setEditTitle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [influencerAccounts, setInfluencerAccounts] = useState<any>([]);
  const [igId, setIgId] = useState<number>(0);
  const [draftAutomation, setDraftAutomation] = useState<AutomationCompleteFormData>({
    automation_form_data: {
      influencer_id: props.UserReducer.influencer_id,
      ig_id: igId,
      automation_name: automationTitle,
      automation_media_type: 'post',
      status: 'Draft',
      ig_automation_id: (ig_automation_id ? Number(ig_automation_id) : 0)
    },
    automation_posts_data: [],
    automation_keywords_data: []
  });

  // Get all accounts of the influencer
  async function getInfluencerAccounts() {
    try {
      setLoading(true);
      let ig_id=igId;
      if (ig_automation_id) {
        const res = await instagramDMAutomationService.getDraftAutomation({
          influencer_id: props.UserReducer.influencer_id,
          ig_automation_id: ig_automation_id
        });
        if (res.status === gtUtil.Constants.SUCCESS) {
          const automation = res.data.rows[0];
          ig_id = automation.ig_id;
          setAutomationTitle(automation.automation_name);
          // setDraftAutomation(automation);

          const parsedPosts = automation.ig_automation_posts
            ? JSON.parse(automation.ig_automation_posts)
            : [];

          const parsedKeywords = automation.ig_automation_keywords
            ? JSON.parse(automation.ig_automation_keywords)
            : [];

          setDraftAutomation({
            automation_form_data: {
              influencer_id: automation.influencer_id,
              ig_id: automation.ig_id,
              automation_name: automation.automation_name,
              automation_media_type: automation.automation_media_type,
              status: automation.status,
              ig_automation_id: (ig_automation_id ? Number(ig_automation_id) : 0)
            },
            automation_posts_data: parsedPosts,
            automation_keywords_data: parsedKeywords
          });
        }
      }
      
      const res = await instagramDMAutomationService.getInfluencerAccounts({
        influencer_id: props.UserReducer.influencer_id,
        ig_id: ig_id
      });

      if (res.status === gtUtil.Constants.SUCCESS) {
        setInfluencerAccounts(res.data.rows);
        setIgId(res.data.rows[0].ig_id);
        setDraftAutomation(prev => ({
          ...prev,
          automation_form_data: {
            ...prev.automation_form_data,
            ig_id: res.data.rows[0].ig_id
          }
        }));
        // Check permissions only if accounts are present
        // if (res.data.rows.length > 0) {
        //   checkInstagramBusinessPermissions(res.data.rows[0]);
        // }
      }
    } catch (error) {
      console.error("Error fetching getInfluencerAccounts:", error);
    } finally {
      setLoading(false);
    }
  }

  const handleEditTitle = (e:any) =>{
    setEditTitle(true)
  }
  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAutomationTitle(e.target.value)
  }
    
  function handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
  }

  const handleInputSubmit = () => {
    if (automationTitle.trim() === '') {
      setAutomationTitle('untitled automation'); 
    }
    setEditTitle(false);
  };

  const inputRef:any = useRef(null);
 
  const handleClickOutside = (e: MouseEvent) => {
    if (inputRef.current && !inputRef.current.contains(e.target as Node)) {
      if (automationTitle.trim() === '') {
        setEditTitle(false); // Close input if empty
      } else {
        handleInputSubmit(); // Submit input if not empty
      }
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleInputSubmit(); // Submit when "Enter" is pressed
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [automationTitle]);

  // const breadcrumbs = [
  //   <Link underline="hover" key="1" color="inherit" href="/" onClick={handleClick}>
  //     My Automations
  //   </Link>,
  //   <Typography key="3" sx={{ color: 'text.primary', display:'flex', fontWeight:'bold' }}>
  //     <span>{!editTitle ? automationTitle ? automationTitle: "untitled automation" : 
  //     <input ref={inputRef} onKeyDown={handleKeyDown} type='text' onChange={handleTitleChange} name="automation_title" value={automationTitle} placeholder={automationTitle} className={`${editTitle ? "automation-edit-title-input" : ""}`} />} </span><IconButton onClick={handleEditTitle} size='small' className='p-0 automation-edit-title bg-none'><MaterialSymbol  iconName='edit' fontweight='200' /></IconButton>
  //   </Typography>,
  // ];
  const breadcrumbs = [
    <Link key="1" color="inherit" to={'/influencer/tools/available-automation'}>
      My Automations
    </Link>,
    <Typography key="3" sx={{ color: 'text.primary', display:'flex', fontWeight:'bold' }}>
      {
        draftAutomation.automation_form_data.status === 'Draft'
        ?
        <>
          <span>
            {
              !editTitle 
              ? 
              (automationTitle ? automationTitle : "untitled automation") 
              : 
              <input ref={inputRef} onKeyDown={handleKeyDown} type='text' onChange={handleTitleChange} name="automation_title" value={automationTitle} placeholder={automationTitle} className={`${editTitle ? "automation-edit-title-input" : ""}`} />
            } 
          </span>
          <IconButton onClick={handleEditTitle} size='small' className='p-0 automation-edit-title bg-none'>
            <MaterialSymbol iconName='edit' fontweight='200' />
          </IconButton>
        </>
        :
        <span>
          {(automationTitle ? automationTitle : "untitled automation")}
        </span>
      }
    </Typography>,
  ];

  // var productImageSlider = {
  //   dots: false,
  //   arrows: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 5000,
  //   pauseOnHover: false,
  //   accessibility: false,
  //   infinite: false,
  //   centerMode: true,        
  //   centerPadding: '20%',
  // };

  useEffect(() => {
    getInfluencerAccounts();
  }, [props.UserReducer.influencer_id]);
    
  return (
    <section className='new-automation'>
      <div className='container '>
        <Breadcrumbs className='mb-5 fs-18 breadcrumb-automation' separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb">
          {breadcrumbs}
        </Breadcrumbs>
        <div className='automation-select'>
          <span className='pb-2 d-block'>Start automation on</span>
          <div className='input-checkbox-box-container'>
            <span
              onClick={() =>
                setAutomationSelect({
                  post: 'post',
                })
              }
              className={
                `input-checkbox-box d-inline-flex
                ${(automationSelect.post + '').toLocaleLowerCase() === 'post'
                ? ' active'
                : ''}`
              }
            >  
              <span className='input-checkbox-box-label d-flex flex-column'>
                <strong>Post or Reel Comments</strong>
                <span>When a user comments on your Post or Reel</span>
              </span>
            </span>
            <span
              onClick={() =>
                {
                  // setAutomationSelect({
                  //   post: 'story',
                  // })
                  localService.toastify('Coming Soon!', 'info', 2000);
                }
              }
              className={
                `input-checkbox-box d-inline-flex nav-link
                ${(automationSelect.post + '').toLocaleLowerCase() === 'story'
                ? 'active'
                : ''}`
              }
            >
              <span className='input-checkbox-box-label d-flex flex-column'>
                <strong>Story Replies</strong>
                <span>When a user replies to your Story</span>
              </span>
            </span>
          </div>
        </div>
        <div className='automation-main-content'>
          {/* <div className='automation-phone-mockup'>
            <img src={phoneMockup} alt="" className='automation-phone-mockup-img' />
            <div className='automation-phone-mockup-user-sec'>
              <img src={userAvatar} alt="" className='automation-phone-mockup-user-img' />
              <div className='automation-phone-mockup-user-info'>
                <strong>Chandrayee Chattopadhyay</strong>
                <span>Business chat</span>
              </div>
            </div>
            <Slider className='automation-phone-mockup-product-slider' {...productImageSlider}> 
              <div className='automation-phone-mockup-product-detail'>
                <img src={productImage} alt="" className='automation-phone-mockup-product-img' />
                <div className='automation-phone-mockup-product-desc'>
                  <strong>JBL Tune 760C, Wireless Over Ear Active...</strong>
                  <button className='btn btn-grey'>Shop on Amazon</button>
                </div>
              </div>
              <div className='automation-phone-mockup-product-detail'>
                <img src={productImage} alt="" className='automation-phone-mockup-product-img' />
                <div className='automation-phone-mockup-product-desc'>
                  <strong>JBL Tune 760C, Wireless Over Ear Active...</strong>
                  <button className='btn btn-grey'>Shop on Amazon</button>
                </div>
              </div>
              <div className='automation-phone-mockup-product-detail'>
                <img src={productImage} alt="" className='automation-phone-mockup-product-img' />
                <div className='automation-phone-mockup-product-desc'>
                  <strong>JBL Tune 760C, Wireless Over Ear Active...</strong>
                  <button className='btn btn-grey'>Shop on Amazon</button>
                </div>
              </div>
            </Slider>
          </div> */}
          {automationSelect.post.toLowerCase() === 'post' && igId > 0 && (
            <NewAutomationPost influencerAccounts={influencerAccounts} UserReducer={props.UserReducer} automationTitle={automationTitle} igId={igId} draftAutomation={draftAutomation} />
          )}
          {automationSelect.post.toLowerCase() === 'story' && (
            <NewAutomationStory />
          )}
        </div>
      </div>
    </section>
  )
}

// export default NewAutomation
const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    // updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(NewAutomation);

export { connectToRedux as NewAutomation };